import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=5384cb9b&scoped=true"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"
import style0 from "./Details.vue?vue&type=style&index=0&id=5384cb9b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5384cb9b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3254644805/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5384cb9b')) {
      api.createRecord('5384cb9b', component.options)
    } else {
      api.reload('5384cb9b', component.options)
    }
    module.hot.accept("./Details.vue?vue&type=template&id=5384cb9b&scoped=true", function () {
      api.rerender('5384cb9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Users/Details.vue"
export default component.exports